import React, { useCallback, useState } from 'react'
import styled from 'styled-components/native'

import I18n from 'APP/I18n'

import WebContentView from 'APP/Components/WebContentView'
import Checkbox from 'APP/Converse/Inputs/Checkbox'
import RadioGroup from 'APP/Converse/Inputs/RadioGroup'
import { ResponsiveWebView } from 'APP/Converse/Layout'
import { FormState, ConsentState } from '../types'
import { FamilyMemberType } from 'APP/Services/Scribe/types'

interface ConsentFormProps {
  form: FormState
  setState: (state: string) => void
}

const Container = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
`

const FormContent = styled.View`
  width: 100%;
`

const ConsentFormContainer = styled(ResponsiveWebView)<{ hide: boolean }>`
  ${({ hide }) => hide && 'height: 0; opacity: 0; margin-vertical: 0;'}
`

const ConsentForm: React.FC<ConsentFormProps> = ({ form, setState }) => {
  const { member, uri } = form
  const { type } = member
  const [loaded, setLoaded] = useState(form.loaded)

  const showRadioGroup = type === FamilyMemberType.Child
  const showCheckBox = form.state === ConsentState.Displayed || form.state === ConsentState.Accept
  const showConsentForm = form.state === ConsentState.Displayed || !loaded

  const checkBoxStatus = form.state === ConsentState.Accept ? 'checked' : 'unchecked'

  const handleRadioGroupPress = (value: string) => {
    setState(value)
  }

  const handleCheckBoxPress = () => {
    setState(form.state === ConsentState.Accept ? ConsentState.Displayed : ConsentState.Accept)
  }

  const handleConsentLoad = useCallback(() => {
    setLoaded(true)
  }, [])

  const checkBoxLabel =
    member.type === FamilyMemberType.Child
      ? I18n.t('ConsentScreen.accept.dependant', { ...member })
      : I18n.t('ConsentScreen.accept.primary')

  return (
    <Container>
      <FormContent>
        {showRadioGroup && (
          <RadioGroup
            label={I18n.t('ConsentScreen.guardianshipConfirmation', { ...member })}
            currentValue={form.state!}
            options={[
              {
                label: I18n.t('ConsentScreen.actions.yes'),
                value:
                  form.state === ConsentState.Accept ? ConsentState.Accept : ConsentState.Displayed,
              },
              { label: I18n.t('ConsentScreen.actions.no'), value: ConsentState.NotApplicable },
            ]}
            onPress={handleRadioGroupPress}
          />
        )}
        {showCheckBox && (
          <Checkbox
            label={checkBoxLabel}
            status={checkBoxStatus}
            testID="CONSENT_SCREEN_ACCEPT_CHECK"
            onPress={handleCheckBoxPress}
            disabled={!loaded}
          />
        )}
      </FormContent>

      <ConsentFormContainer hide={!showConsentForm}>
        <WebContentView
          autoHeight
          showInnerShadow
          uri={uri}
          onLoad={handleConsentLoad}
          screen="consent"
          nestedScrollEnabled={false}
        />
      </ConsentFormContainer>
    </Container>
  )
}

export default ConsentForm
